/**
 * Classe de parâmetros de configuração do sistema
 *
 * @class Configuracao
 */

export default class Configuracao {

    static SUPER_ADMINISTRADOR = 'ADMINISTRADOR';
    static PERFIL_ASSESSOR = 'ASSESSOR';
    static PERFIL_MAGISTRADO = 'MAGISTRADO';
    static PERFIL_SECRETARIO = 'SECRETARIO';
    static TAMANHO_PAGINA = 20;

    static COD_ELEMENTO_DOMINIO_PARTE = 13;
    static COD_COMPLEMENTO_CNJ_PARTE = 1;

    static COD_ELEMENTO_DOMINIO_CLASSE = 63;
    static COD_COMPLEMENTO_CNJ_CLASSE = 5014;



    static DEFAULT_AXIOS_TIMEOUT = 900000;
    static MAX_REGISTROS_AUTOCOMPLETE = 200;
    static CONFIG_URL = process.env.PUBLIC_URL ? process.env.PUBLIC_URL + '/env.json?' + Math.random() : '/env.json?' + Math.random();

    static APP_JSON = process.env.PUBLIC_URL ? process.env.PUBLIC_URL + '/app.json?' + Math.random() : '/app.json?' + Math.random();

}
